import { UpdateLegalClientFirstHeadParams } from 'api/types/params';
import { isFinanceProject, isGlobalProject } from 'config';
import { formatToISODate } from 'helpers';
import {
  parseTaxResidencyParam,
  parsePepConnectionParam,
  parseCitizenshipsParam,
  parseAdditionalInformationFileIdsParam,
  parseAddressWithFilesParam,
} from 'modules/client/common/helpers';
import { parseIdentityDocumentWithFilesParam } from 'modules/client/common/helpers/parseParams/parseIdentityDocumentParam';

import { LegalClientFirstHeadFormType } from '../../forms/legalClientFirstHeadForm';

export const getLegalClientFirstHeadSubmitData = (
  versionNumber: number,
  values: LegalClientFirstHeadFormType
): UpdateLegalClientFirstHeadParams => {
  const addressParam = parseAddressWithFilesParam(values);

  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return {
    versionNumber,
    reason: values.reasonChange.reason,
    firstName: values.personalData.firstName,
    lastName: values.personalData.lastName,
    middleName: values.personalData.middleName ?? null,
    dateOfBirth: values.personalData.dateOfBirth,
    citizenships: parseCitizenshipsParam(values),

    registrationAddress: isFinance
      ? addressParam.registrationAddress
      : undefined,
    residentialAddress: addressParam.residentialAddress,
    placeOfBirth: isGlobal ? addressParam.placeOfBirth : undefined,

    taxResidences: parseTaxResidencyParam(values),

    pepConnection: values.pepConnection.relation?.value!,
    connectedPepInfo: isFinance ? parsePepConnectionParam(values) : undefined,

    positionInCompany: {
      positionInCompany: values.position.position,
      positionConfirmationFileIds:
        values.position.positionConfirmationFiles.map(({ id }) => id!),

      expirationDate: values.position.dateOfExpiration
        ? formatToISODate(values.position.dateOfExpiration)
        : undefined,
    },
    additionalInformationFileIds: parseAdditionalInformationFileIdsParam(
      values.additionalDocumentsFiles
    ),

    identityDocument: parseIdentityDocumentWithFilesParam(values),
  };
};
